import { render, staticRenderFns } from "./Umsatzanalyse.vue?vue&type=template&id=5774a006&"
import script from "./Umsatzanalyse.vue?vue&type=script&lang=ts&"
export * from "./Umsatzanalyse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports